import { Maybe } from '@aibees/shared/definition';
import { UseBoolean, useBoolean } from '@aibees/shared/hooks';
import { useEffect, useMemo } from 'react';
import { Person } from '../../../types';

export function usePeoplePhoto(data?: Person): [UseBoolean, Maybe<string>] {
  const error = useBoolean(false);

  useEffect(() => {
    error.setValue(!data?.profile?.picture?.source);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return useMemo(() => {
    return [error, data?.profile?.picture?.source || ''];
  }, [data?.profile?.picture?.source, error]);
}
